var _style, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.3 115.7",
    style: {
      enableBackground: "new 0 0 108.3 115.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st-shield0{fill:#EFF1FA;stroke:#3703A4;}\n\t.st-shield1{fill:#EFF1FA;stroke:#3703A4;stroke-width:5.3492;}\n\t.st-shield2{fill:#5A34E1;}\n\t.st-shield3{fill:#3703A4;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st-shield0",
    points: "79.2,4.6 31.9,3.4 25.7,6.6 19.1,16.9 8,23.5 3.2,32.8 3.2,53.9 7.1,70 17.9,87.6 32.3,101.8  44.4,110.5 52.4,113.5 62.3,112.2 76.2,102.6 84.8,95.1 92.1,86.8 98.5,76.5 102.4,65.2 105.2,52.4 105.2,40.6 105.2,30.2  100.7,23.7 93.2,19.1 88.7,16.1 84.9,8 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st-shield1",
    d: "M86.5,12.5L86.5,12.5c2.2,4.8,5.5,6.9,8.6,8c4.6,1.6,10.1,5.7,10.1,12.2v12.5c0,29.9-16.6,48.9-39.5,64.2 c-3.3,2.2-7.3,3.4-11.4,3.4c-4.1,0-8.1-1.2-11.4-3.4C19.9,94.1,3.2,75.2,3.2,45.3V32.8c0-6.5,5.6-10.6,10.1-12.2 M86.5,12.5 c-2.2-4.8-7.2-9.2-14.1-9.2H36 M36,3.4 M86.5,12.5 M36,3.4L36,3.4c-6.8,0-11.9,4.4-14.1,9.2c-2.2,4.8-5.5,6.9-8.6,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-shield2",
    d: "M11.2,33.8c0-3.1,2.8-5.6,6.1-6.8c4-1.4,8.3-4.2,11-10.1c1.4-3.1,4.5-5.5,8.3-5.5h30.7c3.9,0,7,2.6,8.6,5.7 c2.2,4.5,6.2,8.1,11.2,10.2c3.1,1.4,5.8,4,5.8,7v11.2c0,24.1-8.6,38.7-31.1,55.4c-2.2,1.6-5,2.6-7.8,2.6s-5.7-0.7-8-2.2 C25.3,87.4,11.2,71,11.2,45.4V33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-shield3",
    d: "M53.4,103.4c0,0,8-13.5,9.2-45.4c1.3-31.9-4.2-46.7-4.2-46.7h10.4c4,0,7.3,2.6,9,5.7 c2.8,5.3,7.5,8.5,11.7,10.2c3.3,1.4,6.1,3.9,6.1,7v11.2c0,24.1-8.9,38.7-32.5,55.4C60.4,102.7,56.9,103.7,53.4,103.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelShield);
export default __webpack_public_path__ + "static/media/level_shield.3bc71d3e0db2c4f3950513e72fff2a7e.svg";
export { ForwardRef as ReactComponent };